import { render, staticRenderFns } from "./SetFlavor.vue?vue&type=template&id=16146136&scoped=true&"
import script from "./SetFlavor.vue?vue&type=script&lang=js&"
export * from "./SetFlavor.vue?vue&type=script&lang=js&"
import style0 from "./SetFlavor.vue?vue&type=style&index=0&id=16146136&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16146136",
  null
  
)

export default component.exports